const PENDING = { id: 1, name: 'Pending'};
const SIGNED = { id: 2, name: 'Signed'};
const APPROVED = { id: 3, name: 'Approved'};

module.exports = {
    PENDING,
    SIGNED,
    APPROVED
}
